import { Location } from 'react-router-dom';
import { ManifestJobTabKey, ManifestJobTabKeys } from './types';

export const getManifestJobActiveTabKey = (location: Location): ManifestJobTabKey => {
    const stateKey = (location.state as { activeTabKey?: ManifestJobTabKey })?.activeTabKey;

    if (stateKey && Object.values(ManifestJobTabKeys).includes(stateKey)) {
        return stateKey;
    }

    const segments = location.pathname.split('/');
    const potentialTabKey = segments[4] as ManifestJobTabKey;

    if (Object.values(ManifestJobTabKeys).includes(potentialTabKey)) {
        return potentialTabKey;
    }

    return ManifestJobTabKeys.OVERVIEW;
};
